import {asset} from '../../images/asset.js';

export const products = [
    {
        id: 1,
        name: "Decorative Handwoven Basket",
        price: 300,
        image: asset.en1,
        description: "A stylish Moonj grass basket with an intricate floral handle design, perfect for serving or décor."
    },
    {
        id: 2,
        name: "Hand-Knitted Sweater",
        price: 800,
        image: asset.en2,
        description: "A vibrant green, hand-knitted sweater featuring intricate patterns and buttons, perfect for cozy winter wear."
    },
    {
        id: 3,
        name: "Earthen Clay Water Bottle",
        price: 450,
        image: asset.en3,
        description: "Beautifully hand-painted earthen clay water bottles, combining traditional craftsmanship with vibrant designs for eco-friendly and stylish hydration."
    },
    {
        id: 4,
        name: "Bulb-Shaped Basket and Small Carry Basket",
        price: 600, // 350 + 250 combined
        image: asset.en4,
        description: "Elegant bulb-shaped baskets, perfect for gifting and home décor needs."
    },
    {
        id: 5,
        name: "Round Basket with Lid",
        price: 450,
        image: asset.en5,
        description: "Handcrafted round basket with a lid, blending utility and style seamlessly."
    },
    {
        id: 6,
        name: "Paper Weight",
        price: 200,
        image: asset.en6,
        description: "Traditional hand-painted clay paperweights, an aesthetic addition to your desk."
    },
    {
        id: 7,
        name: "Baskets",
        price: 200,
        image: asset.en7,
        description: "Durable, eco-friendly handwoven baskets, suitable for multiple uses."
    },
    {
        id: 8,
        name: "Hamper Basket",
        price: 250,
        image: asset.en8,
        description: "Sturdy hamper baskets, perfect for gifting and celebrations."
    },
];
